import React from 'react';
import './footer.css';
import { logo } from './imports';
import { FaLinkedin, FaGithubSquare } from 'react-icons/fa';
const Fotter = () => {
  const date = new Date();
  return (
    <div className="gpt3__footer gradient__bg">
      <img src={logo} alt="" />
      <div className="gpt3__footer-contact">
        <a href="https://www.linkedin.com/in/alex-kreizelman-846178219/">
          <FaLinkedin className="gpt3__footer-contact__icons"></FaLinkedin>
        </a>
        <a href="https://github.com/ak4153">
          <FaGithubSquare className="gpt3__footer-contact__icons"></FaGithubSquare>
        </a>
      </div>
      <div className="gpt3__footer-copyright">
        <p>&#169; Ak Projects {date.getFullYear()}</p>
      </div>
    </div>
  );
};

export default Fotter;
